import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    { orderNumber: string; expand?: ("orderLines" | "shipments" | "vmidetails")[]; customerNumber?: string; },
    GetOrderApiParameter,
    OrderModel
>;

export const PopulateApiParameterExtension: HandlerType = props => {
    props.apiParameter = {
        orderNumber: props.parameter.orderNumber,
        customerNumber: props.parameter.customerNumber,
        expand: props.parameter.expand ?? ["orderLines", "shipments"],
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtension);